import React, { useState, useEffect } from 'react';
import Card from '../../../../component/Card';
import Form from '../../../../component/Form';
import Table from '../../../../component/Table';
import FormHealthCheck from './FormHealthCheck';
import apiService from '../../../../../apiService';


const View = ({
  data,
  score,
  row,
  values,
  handleChange,
  handleSubmit,
  setHealthCheckId,
  penilaianResult,
  examinerName,
  setExaminerName,
  handleInputChange,
  setFieldValue
}) => {
  const [ isHealthCheckCompleted, setIsHealthCheckCompleted ] = useState(false);
  const [hasil, setHasil] = useState([]);
  const [val, setVal] = useState([]);
  const Gethasil = async() =>{
    let x = [];
    const result = await apiService.get('/hotel/answer/read/' + data.hotel_health_check.id );
    if(result && result.code === 200){
      setHasil(result.data);
      result.data.map((d, k)=> {
          x[d.question_id]= {question_id: d.question_id};
      })
      setVal(x);
      setFieldValue(x)
      console.log(values)

    }
  }
  useEffect(() => {
    console.log(row)
   Gethasil()
  }, [hasil.length])
  return (
    <>
      <div className='container-fluid '>
        <div className='row justify-content-center'>
          <div className='col-lg-12'>
            <Card marginTop={ 2 }>
              <Card.Body>
                <h2>Penilaian Pemeriksaan Hotel </h2>
                {/* {penilaianResult.data && penilaianResult.data[ 0 ].result ? ( */}
                  <>
                    <h3>Hasil Penilaian</h3>
                    <div className='row'>
                      <div className='col-2'>Nilai</div>
                      <div className='col'>
                        {penilaianResult.data ? penilaianResult.data[ 0 ].result:''}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-2'>Keterangan</div>
                      <div className='col'>
                        {penilaianResult.data? penilaianResult.data[ 0 ].keterangan : ''}
                      </div>
                    </div>
                  </>
                {/* ) : ( */}
                  <>
                    <div className='form-group row'>
                      <label className='col-md-2 col-form-label form-control-label'>
                        Pemeriksa
                      </label>
                      <div className='col-md-3'>
                        <input
                          className='form-control form-control-sm'
                          value={ values.examinerName }
                          onChange={ (e) => handleInputChange(e) }
                        />
                      </div>
                    </div>
                    <Table
                      headers={ [
                        'No',
                        'Variabel',
                        'Komponen Yang Dinilai',
                        'Bobot',
                        'Skor',
                      ] }
                      data={ row }
                      columnMapper={ (data) => {
                        return [
                          data[ 0 ],
                          <Form.CheckBox
                            options={ data[ 1 ] }
                            onChange={ (e, i) =>
                              handleChange(e, data[ 1 ][ 0 ].id, data[ 1 ][ i ].id)
                            }
                          />,
                          data[ 2 ],
                          data[ 1 ] ? score[ data[ 1 ][ 0 ].id ] * data[ 2 ] || 0 : '',
                        ];
                      } }
                      isBordered
                      pagination={ false }
                    />

                    <div className='row mt-2'>
                      <div className='col d-flex justify-content-end'>
                        <button
                          className='btn btn-success'
                          onClick={ handleSubmit }>
                          Simpan
                        </button>
                      </div>
                    </div>
                  </>
                {/* )} */}
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default View;
